export { default } from './JournalBanner';
